export default "__VITE_ASSET__CrNeGESE__"